import { create } from 'zustand';
import { IPracticeAreas } from '../model';
import { persist } from 'zustand/middleware';

interface IAuxiliarState {
  writing: boolean;
  areas: IPracticeAreas | null;
  setAreas: (areas: IPracticeAreas) => void;
  setWriting: (status: boolean) => void;
}

export const auxiliarStore = create<IAuxiliarState>()(
  persist(
    (set) => ({
      areas: null,
      writing: false,
      setAreas: (areas: IPracticeAreas) => set({ areas }),
      setWriting: (status: boolean) => set({ writing: status }),
    }),
    {
      name: 'practice-create-auxliar',
    }
  )
);
